import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LIBRARY_TRANSLATIONS, flattenTranslations } from '@card-software/library';

@Injectable({
  providedIn: 'root',
})
export class CustomTranslateLoader implements TranslateLoader {
  private readonly http = inject(HttpClient);
  private readonly translationsUrl = 'assets/i18n/translations.json';

  getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get<TranslationObject>(this.translationsUrl).pipe(
      map((appTranslations: TranslationObject) => {
        const libraryFlat = flattenTranslations(LIBRARY_TRANSLATIONS, lang);

        const extractedAppTranslations: TranslationObject = {};
        Object.keys(appTranslations).forEach((key) => {
          if (appTranslations[key][lang]) {
            extractedAppTranslations[key] = appTranslations[key][lang];
          }
        });

        return { ...libraryFlat, ...extractedAppTranslations };
      }),
    );
  }
}
